import React from 'react';
import { Progress, ProgressProps } from 'reactstrap';
import { idGenerator } from '~/lib/helper/IdHelper';

const labelIdGen = idGenerator('labelled-progress-');

interface LabelledProgressProps extends ProgressProps {
    /** Accessible name for the bar, rendered visually-hidden and wired via `barAriaLabelledBy`. */
    label: string;
}

/**
 * A reactstrap `Progress` with a programmatic accessible name.
 *
 * reactstrap spreads a plain `aria-label` onto the outer `.progress` wrapper, not
 * the inner `role="progressbar"` element — so a bare `aria-label` never names the
 * bar (and Biome can't see this). This renders a `visually-hidden` label and points
 * `barAriaLabelledBy` at it, so every progress bar gets a stable name from one place.
 * Each instance gets its own generated label id (one bar per instance).
 */
export default class LabelledProgress extends React.Component<LabelledProgressProps> {
    private readonly labelId = labelIdGen();

    render() {
        const { label, ...progressProps } = this.props;
        return (
            <>
                <span id={this.labelId} className="visually-hidden">
                    {label}
                </span>
                <Progress {...progressProps} barAriaLabelledBy={this.labelId} />
            </>
        );
    }
}
